import { ApiLogLogTracciatoInfocenterPostRequest, Configuration, LogApi, LogTracciatoInfoCenterDtoPagedListDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';
import { pageSize } from 'store/utils';

/* export const setStatoCertificazioneAction = createAction<number, 'setStatoCertificazione'>('setStatoCertificazione');
export const setModalitaCertificazioneAction = createAction<number, 'setModalitaCertificazione'>('setModalitaCertificazione');
export const setNdgAction = createAction<string, 'setNdgAction'>('setNdgAction'); */
export const setPaginaSelezionataAction = createAction<number, 'logTracciato/setPaginaSelezionata'>('logTracciato/setPaginaSelezionata');
export const setDataInizio = createAction<Date, 'logTracciato/setDataInizio'>('logTracciato/setDataInizio');
export const setDataFine = createAction<Date, 'logTracciato/setDataFine'>('logTracciato/setDataFine');


export const postLogTracciatoInfocenterAction = createAsyncThunk<LogTracciatoInfoCenterDtoPagedListDto | undefined, undefined, ThunkApiConfig>(
  'logTracciato//postLogTracciatoInfocenterAction', async (_, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return (await import('../../../../mock/log-tracciato-infocenter.json')).default;
      } else {
        const logInfoCenterState = getState().logTracciatoInfocenter;
        const requestParameters: ApiLogLogTracciatoInfocenterPostRequest = {
          ricercaLogDto: {
            dataInizio: new Date(logInfoCenterState.dataInizio.getFullYear(), logInfoCenterState.dataInizio.getMonth(), logInfoCenterState.dataInizio.getDate(), 0, 0, 0),
            dataFine: new Date(logInfoCenterState.dataFine.getFullYear(), logInfoCenterState.dataFine.getMonth(), logInfoCenterState.dataFine.getDate(), 23, 59, 59),
            pageSize: pageSize,
            pageNumber: logInfoCenterState.paginaSelezionata
          }

        };
        return await new LogApi(getConfiguration(Configuration, extra, getState)).apiLogLogTracciatoInfocenterPost(requestParameters);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);
